import { registerPlugin } from '@capacitor/core';
import type { PushNotificationsExPlugin } from './definitions';

const PushNotificationsEx = registerPlugin<PushNotificationsExPlugin>('PushNotificationsEx');

export * from './definitions';
export { PushNotificationsEx };
